<template>
  <b-form @submit.prevent="handleSubmit" class="search-input">
    <span v-if="rightIcon" class="search-input__right-icon">
      <mdicon :name="rightIcon" size="24" />
    </span>
    <b-form-input
      v-model="inputValue"
      :type="type"
      :placeholder="placeholder"
      :id="id"
      :minLength="minLength"
      :maxLength="maxLength"
      :autocomplete="autocomplete"
      :autofocus="autoFocus"
      :disabled="disabled"
      :state="generateState"
      :aria-describedby="`${id}-help ${id}-feedback`"
      trim
      @focus="focus"
      @blur="blur"
    />
    <span v-if="hasEraseIcon" class="search-input__close" @click="close">
      <mdicon name="close" size="24" />
    </span>
    <Button
      type="submit"
      size="sm"
      variant="primary"
      justIcon="magnify"
      wrapperClass="margin-right-8 width-30 flex-center"
      contentClass="button__just-icon"
      :disabled="!inputValue"
      @click="handleSubmit"
    />
  </b-form>
</template>

<script>
import { Button } from "@/components/re-design/forms";
import { pathOr } from "ramda";

export default {
  components: { Button },
  props: {
    value: {}, // watch model
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "default-id",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vuelidateObj: {
      type: Object,
      default: null,
    },
    minLength: {
      type: [String, Number],
      default: 1,
    },
    maxLength: {
      type: [String, Number],
      default: 256,
    },
    rightIcon: {
      type: String,
      default: null,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    hasEraseIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      /* guidance: watching input value */
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", this.name, val);
      },
    },
    generateState() {
      return this.vuelidateObj.$dirty ? !this.vuelidateObj.$error : null;
    },
  },
  methods: {
    pathOr,
    blur() {
      this.$emit("blur", this.name, this.inputValue);
    },
    focus() {
      this.$emit("focus", this.name);
    },
    close() {
      this.$emit("close");
      if (!this.inputValue) return;
      this.inputValue = null;
      this.erase();
    },
    erase() {
      this.$emit("removeFilter", "search_txt");
    },
    handleSubmit() {
      if (!this.inputValue) return;
      this.$emit("handleSubmit", this.name, this.inputValue, "search_txt");
    },
  },
};
</script>
